/* ============================================================
   syllabus-kinetic.js — standalone kinetic v1 syllabus module.
   Ported from fpdp-kinetic.js FPK.syllabus. Namespaced window.SYL,
   hooks data-syl-* + .syl-* classes, scoped to the section root.
   Boot (GSAP/ScrollTrigger/SplitType + ctx) lives in the liquid.
   ============================================================ */
window.SYL = function(root, ctx){
  ctx = ctx || {};
  var gsap = ctx.gsap, ST = ctx.ScrollTrigger, reduce = !!ctx.reduce, SplitType = ctx.SplitType;
  var fine = (ctx.fine != null) ? !!ctx.fine
    : (window.matchMedia ? window.matchMedia('(pointer:fine)').matches : false);

  var headline = root.querySelector('[data-syl-headline]');
  var rows   = Array.prototype.slice.call(root.querySelectorAll('[data-syl-row]'));
  var fill   = root.querySelector('[data-syl-fill]');
  var pShine = root.querySelector('[data-syl-shine]');
  var pLabel = root.querySelector('[data-syl-plabel]');
  var rises  = Array.prototype.slice.call(root.querySelectorAll('[data-syl-rise]'));
  var lives  = Array.prototype.slice.call(root.querySelectorAll('.syl-live'));
  var TOTAL  = rows.length || 9;

  function paint(n){ if(pLabel) pLabel.textContent = n + ' / ' + TOTAL + ' mapped'; }

  var E = { pop:'back.out(1.7)', spring:'elastic.out(1,0.55)', mkspring:'elastic.out(1,0.4)', nn:'elastic.out(1,0.5)', in:'power3.in' };

  // ---------- accordion: animated height + spring +->x marker ----------
  function setupAccordion(animated){
    rows.forEach(function(row){
      var head = row.querySelector('[data-syl-head]');
      var body = row.querySelector('[data-syl-body]');
      var mk   = row.querySelector('[data-syl-mk]');
      if(!head || !body) return;
      var inner = body.firstElementChild;
      body.style.height = '0px';
      head.addEventListener('click', function(){
        var isOpen = row.classList.contains('is-open');
        if(isOpen){
          row.classList.remove('is-open');
          head.setAttribute('aria-expanded','false');
          if(animated && gsap){
            gsap.to(body, { height:0, duration:0.4, ease:'power2.inOut', overwrite:true });
            if(mk) gsap.to(mk, { rotation:0, duration:0.5, ease:E.mkspring, overwrite:true });
          } else {
            body.style.height = '0px';
            if(mk) mk.style.transform = 'rotate(0deg)';
          }
        } else {
          row.classList.add('is-open');
          head.setAttribute('aria-expanded','true');
          var h = inner ? inner.offsetHeight : 0;
          if(animated && gsap){
            gsap.fromTo(body, { height:0 }, { height:h, duration:0.46, ease:'power3.out', overwrite:true,
              onComplete:function(){ if(row.classList.contains('is-open')) body.style.height = 'auto'; } });
            if(mk) gsap.to(mk, { rotation:45, duration:0.55, ease:E.mkspring, overwrite:true });
          } else {
            body.style.height = 'auto';
            if(mk) mk.style.transform = 'rotate(45deg)';
          }
        }
      });
    });
  }

  // ---------- no GSAP / reduced motion: resting state ----------
  if(!gsap || reduce){
    if(fill) fill.style.transform = 'scaleX(1)';
    rows.forEach(function(r){ r.style.opacity = '1'; });
    rises.forEach(function(r){ r.style.opacity = '1'; });
    paint(TOTAL);
    setupAccordion(false);
    return;
  }

  if(ST) gsap.registerPlugin(ST);
  root.classList.add('syl-js');

  // ---------- kinetic headline: mask + skew + scale reveal ----------
  var split = null;
  if(SplitType && headline){
    try{
      split = new SplitType(headline, { types:'lines' });
      split.lines.forEach(function(l){
        var w = document.createElement('span');
        w.className = 'syl-linemask';
        l.parentNode.insertBefore(w, l);
        w.appendChild(l);
      });
    }catch(e){ split = null; }
  }
  if(split && split.lines.length){
    gsap.set(split.lines, { yPercent:120, skewY:6, scaleY:1.14, transformOrigin:'left top', willChange:'transform' });
    gsap.to(split.lines, {
      yPercent:0, skewY:0, scaleY:1, duration:0.62, ease:E.pop, stagger:0.07,
      scrollTrigger:{ trigger:headline, start:'top 84%' },
      onComplete:function(){ gsap.set(split.lines, { clearProps:'transform,willChange' }); }
    });
  } else if(headline){
    gsap.set(headline, { yPercent:110, opacity:0 });
    gsap.to(headline, {
      yPercent:0, opacity:1, duration:0.62, ease:E.pop,
      scrollTrigger:{ trigger:headline, start:'top 84%' },
      onComplete:function(){ gsap.set(headline, { clearProps:'transform' }); }
    });
  }

  var rt;
  window.addEventListener('resize', function(){
    clearTimeout(rt);
    rt = setTimeout(function(){
      if(split){ try{ split.revert(); }catch(e){} split = null; if(headline) gsap.set(headline, { clearProps:'all' }); }
      ST && ST.refresh();
    }, 200);
  });

  // ---------- eyebrow / sub / meter rise ----------
  if(rises.length){
    gsap.set(rises, { y:30, opacity:0 });
    gsap.to(rises, {
      y:0, opacity:1, duration:0.5, ease:E.pop, stagger:0.06,
      scrollTrigger:{ trigger:root, start:'top 82%' },
      onComplete:function(){ gsap.set(rises, { clearProps:'transform' }); }
    });
  }

  // ---------- master timeline: rows stagger-reveal + number punch + meter notch + counter ----------
  if(fill) gsap.set(fill, { scaleX:0, transformOrigin:'left center' });
  if(lives.length) gsap.set(lives, { scale:0.4, opacity:0, transformOrigin:'center center' });
  paint(0);
  var counter = { v:0 };
  gsap.set(rows, {
    y:44, scale:0.94, opacity:0,
    rotate:function(i){ return i % 2 ? 0.6 : -0.6; },
    transformOrigin:'center center', willChange:'transform'
  });

  var listEl = root.querySelector('[data-syl-acc]');
  var master = gsap.timeline({
    scrollTrigger:{ trigger:listEl || root, start:'top 80%', once:true },
    onComplete:function(){ gsap.set(rows, { clearProps:'transform,willChange' }); }
  });

  rows.forEach(function(row, i){
    var shine = row.querySelector('[data-syl-rowshine]');
    var live  = row.querySelector('.syl-live');
    var lring = row.querySelector('[data-syl-livering]');
    var nn    = row.querySelector('.syl-nn');
    var at = i * 0.12;

    master.to(row, { y:0, scale:1, rotate:0, opacity:1, duration:0.55, ease:E.pop }, at);

    if(nn){
      master.fromTo(nn, { scale:0.4 }, {
        scale:1, duration:0.55, ease:E.nn,
        onComplete:function(){ gsap.set(nn, { clearProps:'transform' }); }
      }, at + 0.08);
      master.fromTo(nn, { color:'#3ef08a' }, {
        color:'#0c9a5f', duration:0.5, ease:'power2.out',
        onComplete:function(){ gsap.set(nn, { clearProps:'color' }); }
      }, at + 0.08);
    }

    if(shine){
      master.fromTo(shine, { xPercent:-160, opacity:0 }, {
        xPercent:260, opacity:1, duration:0.7, ease:'power2.inOut',
        onComplete:function(){ gsap.to(shine, { opacity:0, duration:0.2 }); }
      }, at + 0.06);
    }
    if(live){
      master.fromTo(live, { scale:0.4, opacity:0 }, {
        scale:1, opacity:1, duration:0.5, ease:E.spring,
        onComplete:function(){ gsap.set(live, { clearProps:'transform' }); }
      }, at + 0.12);
      if(lring){
        master.fromTo(lring, { scale:0.7, opacity:0.9 }, {
          scale:1.5, opacity:0, duration:0.7, ease:'power2.out',
          onComplete:function(){ gsap.set(lring, { clearProps:'transform' }); }
        }, at + 0.12);
      }
    }
    if(fill){
      master.to(fill, { scaleX:(i + 1) / TOTAL, duration:0.4, ease:'power3.out' }, at + 0.06);
    }
    master.to(counter, {
      v:i + 1, duration:0.4, ease:'power1.out', snap:{ v:1 },
      onUpdate:function(){ paint(Math.round(counter.v)); }
    }, at + 0.06);
    if(pLabel){
      master.to(pLabel, { scale:1.18, duration:0.14, ease:'power2.out', yoyo:true, repeat:1 }, at + 0.06);
    }
  });

  if(pShine){
    master.fromTo(pShine, { xPercent:-160, opacity:0 }, {
      xPercent:340, opacity:1, duration:0.7, ease:'power2.inOut',
      onComplete:function(){ gsap.to(pShine, { opacity:0, duration:0.2 }); }
    }, '>-0.1');
  }

  setupAccordion(true);

  // ---------- per-row micro-interactions (fine pointers) ----------
  if(fine){
    rows.forEach(function(row){
      var head  = row.querySelector('[data-syl-head]');
      var shine = row.querySelector('[data-syl-rowshine]');
      if(!head) return;

      var xTo = gsap.quickTo(head, 'x', { duration:0.4, ease:'power3' });
      var yTo = gsap.quickTo(head, 'y', { duration:0.4, ease:'power3' });
      head.addEventListener('pointermove', function(e){
        var r = head.getBoundingClientRect();
        var mx = (e.clientX - r.left) / r.width - 0.5;
        var my = (e.clientY - r.top) / r.height - 0.5;
        xTo(mx * 7);
        yTo(my * 3 - 3);
      });
      head.addEventListener('pointerleave', function(){
        gsap.to(head, { x:0, y:0, duration:0.5, ease:'back.out(2)' });
      });

      if(shine){
        head.addEventListener('pointerenter', function(){
          gsap.fromTo(shine, { xPercent:-160, opacity:1 }, {
            xPercent:260, opacity:1, duration:0.7, ease:'power2.inOut',
            onComplete:function(){ gsap.to(shine, { opacity:0, duration:0.2 }); }
          });
        });
      }
      head.addEventListener('pointerdown', function(e){
        var r = head.getBoundingClientRect();
        var rp = document.createElement('span');
        rp.className = 'syl-ripple';
        rp.style.left = (e.clientX - r.left) + 'px';
        rp.style.top  = (e.clientY - r.top) + 'px';
        head.appendChild(rp);
        gsap.fromTo(rp, { scale:0, opacity:0.4 }, {
          scale:4, opacity:0, duration:0.6, ease:'power2.out',
          onComplete:function(){ rp.remove(); }
        });
        gsap.to(head, { scale:0.97, duration:0.09, yoyo:true, repeat:1, ease:E.in });
      });
    });
  }
};
